import { render, staticRenderFns } from "./privacy-policy.page.vue?vue&type=template&id=460068d4"
import script from "./privacy-policy.page.vue?vue&type=script&lang=js"
export * from "./privacy-policy.page.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.page.vue?vue&type=style&index=0&id=460068d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports